import financeiroApi from './financeiroApi';

const PATH = '/api/v1/backend/conta-pagar/recorrencia';

export default {
  buscar: async (params) =>
    financeiroApi.get(`${PATH}`, {
      params,
    }),
  atualizar: async (id, contaspagar) => {
    return financeiroApi.put(`${PATH}/${id}`, contaspagar);
  },
  resgatar: async (params) => {
    return financeiroApi.put(`${PATH}/resgatar`, params);
  },
  deletar: async (filtro) => {
    return financeiroApi.delete(PATH, { data: filtro });
  },
};
